export default __webpack_public_path__ + "static/media/amazon.5d682cc5.svg";